import styled from "styled-components";

export const Type = styled.div`
  padding: 10px;

  background-color: ${({ theme, read }) =>
    read ? theme.colors.neutral.cinza200 : `${theme.colors.primary.blue}50`};

  display: flex;
  align-items: center;
  justify-content: center;

  width: 70px;
  height: 60px;

  border-radius: 100px;
`;
